import { AsyncReturnType } from "type-fest";

import { ServerStorage } from "@/services";
import { UseMutationSimpleOptions, useMutation } from "@/services/hooks";

type Variables = Parameters<typeof ServerStorage.patch>[0];
type Data = AsyncReturnType<typeof ServerStorage.patch>;
type Error = unknown;

export const usePatchServerStorage = <TContext = unknown>(
  options?: UseMutationSimpleOptions<Data, Error, Variables, TContext>
) => {
  const result = useMutation<Data, Error, Variables, TContext>(
    ServerStorage.patch,
    options
  );

  return result;
};
